import { render } from "./WaterChart.vue?vue&type=template&id=3391d4c0&ts=true"
import script from "./WaterChart.vue?vue&type=script&lang=ts"
export * from "./WaterChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__